define('app/filters/controls/BooleanFilterControl',['require','glu/itemView','hbs!./BooleanFilterControl.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView');

	return ItemView.extend({
		template: require('hbs!./BooleanFilterControl.hbs'),
		tagName: 'span',
		events: {
			'change select': 'updateModel'
		},

		initialize: function() {
			this.model.setArity(1);
		},

		onRender: function() {
			if (this.model.get('values')[0]) {
				this.$el.find('select').val(String(this.model.get('values')[0]));
			}
		},

		serializeData: function() {
			return this;
		},

		getValue: function() {
			return this.model.getValue(0);
		},

		updateModel: function() {
			this.model.setValue(0, this.$el.find('select').val());
		}
	});

});

